import React, { useEffect } from "react";
import { Layout, MainContent } from "../components";
import { userActions } from "../actions";
import { browserName, osName } from "react-device-detect";
import { ThemeProvider } from "../ThemeContext";
import { useStore } from "react-redux";
import { setFirstLoadDone } from "../store/casesClientSearchSlice";
import { shouldCreateDeviceSession } from "../utils/session/deviceSessionBootstrap";
import { useAppDispatch, useAppSelector } from "../types/hooks";
import type { RootState } from "../types/store";

export default function TaxManagementSection() {
  const dispatch = useAppDispatch();
  const store = useStore();
  const users = useAppSelector((state) => state.users);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      let ip = "0.0.0.0";
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        if (typeof data?.ip === "string" && data.ip.trim()) {
          ip = data.ip.trim();
        }
      } catch {
        /* ipify optional; session is still created */
      }
      if (cancelled) return;

      const snapshot = store.getState() as RootState;
      const firstLoadDone = snapshot.casesClientSearch?.firstLoadDone ?? false;
      const device_token = snapshot.auth?.deviceToken ?? null;
      const session_id = snapshot.auth?.sessionId ?? null;
      const needsNewSession = shouldCreateDeviceSession(device_token, session_id);

      if (firstLoadDone === false || needsNewSession) {
        dispatch(setFirstLoadDone(true));
        dispatch(userActions.createSession(ip, `${browserName},${osName}`));
      } else {
        dispatch(userActions.checkSessionValidity());
        if (device_token && session_id) {
          dispatch(userActions.getAll(device_token, session_id));
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, store]);

  return (
    <div>
      <div>
        <ThemeProvider>
          <Layout users={users}>
            <MainContent users={users} matchRoute={{}} />
          </Layout>
        </ThemeProvider>
      </div>
    </div>
  );
}
